const defaultBrandCopy = {
  headlineButton: 'Apply now',
  qualificationA: 'You are crazy about our brand',
  qualificationB: 'You want to share our mission to your friends',
  representativeQuote: 'We need ambassadors like you to support our mission!',
  acceptedEmail: 'From now on you will receive stories directly from us. We\'ll be in touch!',
}

export default defaultBrandCopy
